(() => {
  const marker = document.querySelector('[data-duo-pdp-layout]');
  const root = marker?.closest('main')?.querySelector('.torras-main-product');
  if (!root || root.dataset.duoLayoutReady) return;
  root.dataset.duoLayoutReady = 'true';
  const grid = root.querySelector('.torras-main-product__grid');
  const title = root.querySelector('.torras-main-product__title');
  const badge = root.querySelector('.torras-main-product__badge');
  if (!grid || !title) return;
  if (badge && marker.dataset.badge) badge.textContent = marker.dataset.badge;
  const items = [badge, title].filter(Boolean).map((element) => {
    const anchor = document.createComment('duo-title-position');
    element.before(anchor);
    return { element, anchor };
  });
  const header = document.createElement('div');
  header.className = 'duo-pdp-mobile-heading';
  grid.prepend(header);
  const mobile = window.matchMedia('(max-width: 749px)');
  const update = () => {
    for (const { element, anchor } of items) {
      if (mobile.matches) header.append(element);
      else anchor.after(element);
    }
    header.hidden = !mobile.matches;
  };
  mobile.addEventListener('change', update);
  update();
})();
